import { connect } from 'react-redux';
import _ from 'lodash';

import {
  addFilterClause,
  copyFilter,
  removeFilter,
  removeFilterClause,
  setClausesConcatOperator,
  setFilterClauseField,
  setFilterClauseOperator,
  setFilterClauseValue,
  setFilterVisibility,
} from '../../../../../actions/dashboards/retentionComplex';
import {
  getFieldPathKeys,
  getFieldPathsFor,
  getMetainf,
  getProjectZoneId,
  getDashboardsRetentionFirstEvent,
  getDashboardsRetentionReturnEvent,
  getDashboardsRetentionFilterFor,
} from '../../../../../reducers/analyticsApp';
import EventFilterContainer from '../../../../../components/filter/EventFilterContainer';
import {
  filterClauses,
  getEventAttributes,
  getTransferFieldsObject,
  isNotEmptyClause,
} from '../../../../../utils/filter';

const mapStateToProps = (state, { event, eventIndex, unitId }) => {
  const filter = getDashboardsRetentionFilterFor(state, unitId, eventIndex);
  return {
    firstEvent: getDashboardsRetentionFirstEvent(state, unitId),
    secondEvent: getDashboardsRetentionReturnEvent(state, unitId),
    getFieldFor: (path) => getFieldPathsFor(state, path),
    getFieldKeys: () => getFieldPathKeys(state),
    eventId: eventIndex,
    metainf: getMetainf(state, event),
    zoneId: getProjectZoneId(state),
    concatOperator: filter.concatOperator,
    clauses: filter.clauses,
    visibility: filter.visibility,
    badgeCount: filter.clauses.filter(isNotEmptyClause).length,
  };
};

const mapDispatchToProps = (dispatch, { eventIndex, unitId }) => ({
  setFilterVisibility: (value) => dispatch(setFilterVisibility(unitId, eventIndex, value)),
  onAddFilterClause: () => dispatch(addFilterClause(unitId, eventIndex)),
  onCopy: (clauses) => dispatch(copyFilter(unitId, eventIndex, clauses)),
  onRemoveFilter: () => dispatch(removeFilter(unitId, eventIndex)),
  onRemoveFilterClause: (...rest) => dispatch(removeFilterClause(unitId, eventIndex, ...rest)),
  onSelectFilterClauseField: (...rest) =>
    dispatch(setFilterClauseField(unitId, eventIndex, ...rest)),
  onFilterClauseValueChange: (...rest) =>
    dispatch(setFilterClauseValue(unitId, eventIndex, ...rest)),
  onSetClausesConcatOperator: (...rest) =>
    dispatch(setClausesConcatOperator(unitId, eventIndex, ...rest)),
  onSelectFilterClauseOperator: (...rest) =>
    dispatch(setFilterClauseOperator(unitId, eventIndex, ...rest)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onCopyFilter: (copyFilters) => {
    let copyFiltersVar = copyFilters;

    if (
      stateProps.firstEvent !== stateProps.secondEvent &&
      copyFiltersVar.filter(({ field }) => field).length
    ) {
      const fieldTypes = copyFiltersVar.map(({ field }) =>
        stateProps
          .getFieldKeys()
          .flatMap((pathKey) => stateProps.getFieldFor(pathKey))
          .find((s) => s.path === field)
      );

      const { firstEventFields, secondEventFields } = getEventAttributes(
        stateProps.metainf,
        stateProps.firstEvent,
        stateProps.secondEvent
      );
      // общие атрибуты по label
      const commonAttributes = _.intersectionBy(firstEventFields, secondEventFields, 'label');

      const filteredFields = getTransferFieldsObject(
        fieldTypes,
        commonAttributes,
        secondEventFields
      );

      copyFiltersVar = copyFiltersVar.reduce((res, clause) => {
        if (filteredFields[clause.field]) {
          return res.concat({ ...clause, field: filteredFields[clause.field] });
        }

        return res;
      }, []);
    }

    dispatchProps.onCopy(filterClauses(stateProps.metainf, copyFiltersVar));
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EventFilterContainer);
